(function () {
  function activateTab(scope, target) {
    var tabs = scope.querySelectorAll('[role="tab"]');
    var panels = scope.querySelectorAll('[role="tabpanel"]');
    tabs.forEach(function (t) {
      var match = t.getAttribute('aria-controls') === target;
      t.setAttribute('aria-selected', match ? 'true' : 'false');
      t.tabIndex = match ? 0 : -1;
    });
    panels.forEach(function (p) {
      p.classList.toggle('is-active', p.id === target);
    });
  }

  function initScope(scope) {
    var tabs = scope.querySelectorAll('[role="tab"]');
    if (!tabs.length) return;
    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        activateTab(scope, tab.getAttribute('aria-controls'));
      });
      tab.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var dir = e.key === 'ArrowRight' ? 1 : -1;
        var next = (i + dir + tabs.length) % tabs.length;
        tabs[next].focus();
        activateTab(scope, tabs[next].getAttribute('aria-controls'));
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-ergotec-tabs]').forEach(initScope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
